<template>
	<div
		class="g-block-title-diamond-accent g-block-title-padding"
		:class="{
			'g-block-title-diamond-accent--edit': editable,
			'is-active': editable && active,
			'g-block-title-diamond-accent--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-diamond-accent__row">
			<span class="g-block-title-diamond-accent__gem" :style="{ background: themeColor }" aria-hidden="true"></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-diamond-accent__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-diamond-accent__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<span class="g-block-title-diamond-accent__gem" :style="{ background: themeColor }" aria-hidden="true"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleDiamondAccent',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-diamond-accent {
		.title-block-edit-shell();
	}

	.g-block-title-diamond-accent__row {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	.g-block-title-diamond-accent__gem {
		width: 8px;
		height: 8px;
		flex-shrink: 0;
		transform: rotate(45deg);
	}

	.g-block-title-diamond-accent__text {
		font-size: 20px;
		font-weight: 700;
		line-height: 1.3;
		text-align: center;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; text-align: center; }
	}

	.g-block-title-diamond-accent--h5 {
		.g-block-title-diamond-accent__row { gap: 0.24rem; }
		.g-block-title-diamond-accent__gem { width: 0.16rem; height: 0.16rem; }
		.g-block-title-diamond-accent__text { font-size: 0.4rem; }
	}
</style>
